export default __webpack_public_path__ + "static/media/architecturals.a3f9dc37.jpg";